import { FC, MutableRefObject, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { RightNavButton, LeftNavButton } from './SliderComponents';

interface Props {
    children: any;
    itemWidth: number;
    itemsToSlide?: number;
    className: string;
    itemHeight: number;
}
export const TileSlider: FC<Props> = ({
    children,
    itemWidth = 200,
    itemsToSlide = 4,
    className,
    itemHeight,
    ...props
}) => {
    const [offset, setOffset] = useState(0);
    const [, setParentWidth] = useState(2000);
    const [itemsToShow, setItemsToShow] = useState(0);
    const sliderRef = useRef() as MutableRefObject<HTMLDivElement>;

    function slideOffset(slOffset) {
        let nextOffset = offset + slOffset;
        if (nextOffset < 0) {
            nextOffset = 0;
        }
        if (nextOffset + itemsToShow >= children.length) {
            nextOffset = children.length - itemsToShow + 1;
        }
        setOffset(nextOffset);
    }
    const updateState = useCallback(() => {
        const parentWidthState = sliderRef.current.offsetWidth;
        let itemsToShow = children.length;
        if (sliderRef.current) {
            itemsToShow = Math.min(itemsToShow, Math.floor(parentWidthState / itemWidth));
        }
        setItemsToShow(itemsToShow);
        setParentWidth(parentWidthState);
    }, [children?.length, itemWidth]);

    const handleResize = useCallback(() => {
        updateState();
    }, [updateState]);

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        updateState();
        return () => window.removeEventListener('resize', handleResize);
    }, [handleResize, props, updateState]);

    let disabled = true;

    const childrenItems: ReactNode = [];
    if (children) {
        children.forEach((child, index) => {
            childrenItems[index] = (
                <div key={index} style={{ width: `${itemWidth}px` }}>
                    {child}
                </div>
            );
        });

        disabled = offset + itemsToShow - 1 >= children.length || itemsToShow === children.length;
    }

    const sliderClassName = `slider ${className ?? ''}`;

    return (
        <div data-displayname="TileSlider" className={sliderClassName} ref={sliderRef}>
            <LeftNavButton onClick={() => slideOffset(-itemsToSlide)} disabled={offset === 0} itemHeight={itemHeight} />
            <div
                data-cy="slider-track"
                className="slider-track native-slide"
                style={{
                    width: `${itemWidth * children.length}px`,
                    left: `${-itemWidth * offset + 15}px`
                }}
            >
                {childrenItems}
            </div>
            <RightNavButton onClick={() => slideOffset(itemsToSlide)} disabled={disabled} itemHeight={itemHeight} />
        </div>
    );
};
